/**
 * Hardway Sale Patch
 *
 * Reads window.HW_SALE (set by snippets/hw-sale-patch.liquid) and applies
 * a visual sale to every product card on the page:
 *   - Strikethrough original price
 *   - Discounted price shown as current
 *   - Sale tag with the percentage
 *
 * Works with the WCP wholesale app: each card's .grid-product__price element
 * carries a data-hw-price attribute (cents) populated by Liquid, which is
 * already the dealer price for wholesale customers.
 *
 * Safe to run multiple times (idempotent via data-hw-sale-done flag).
 * Watches for AJAX-loaded cards (infinite scroll, collection filtering).
 */
(function () {
  'use strict';

  var cfg = window.HW_SALE;
  if (!cfg || !cfg.pct || cfg.pct <= 0) return;

  // ── Expiry check ────────────────────────────────────────────────────────────
  if (cfg.ends) {
    // Treat end date as end-of-day in local time
    var endDate = new Date(cfg.ends + 'T23:59:59');
    if (isNaN(endDate.getTime()) || Date.now() > endDate.getTime()) return;
  }

  var multiplier = 1 - cfg.pct / 100;

  // ── Money formatting ─────────────────────────────────────────────────────────
  function formatMoney(cents) {
    // Use Shopify's built-in formatter when available (respects store currency)
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var fmt =
        (window.theme && window.theme.moneyFormat) ||
        (window.Shopify && window.Shopify.money_format) ||
        '${{amount}}';
      try { return Shopify.formatMoney(cents, fmt); } catch (e) { /* fall through */ }
    }
    // Fallback: plain USD
    var dollars = cents / 100;
    return '$' + dollars.toFixed(2).replace(/\.00$/, '');
  }

  // ── Apply sale to one product card ──────────────────────────────────────────
  function applyToCard(card) {
    if (card.dataset.hwSaleDone) return;
    card.dataset.hwSaleDone = '1';

    // Liquid marks only eligible products with data-hw-sale="1".
    // If the attribute is absent this product is not covered by the active
    // discount and we leave it completely untouched.
    var priceWrap = card.querySelector('.grid-product__price[data-hw-sale="1"]');
    if (!priceWrap) return;

    var currentEl = priceWrap.querySelector('.grid-product__price--current');
    if (!currentEl) return;

    // Skip cards already showing a WCP compare-at sale price
    if (priceWrap.querySelector('.grid-product__price--original')) return;

    // Read price in cents from data attribute (set by Liquid via wcp_price)
    var priceCents = parseInt(priceWrap.dataset.hwPrice, 10);
    if (!priceCents || priceCents <= 0) return;

    var saleCents = Math.round(priceCents * multiplier);

    // Build strikethrough original element using the already-formatted text
    var originalEl = document.createElement('span');
    originalEl.className = 'grid-product__price--original';
    originalEl.setAttribute('aria-label', 'Original price');
    originalEl.textContent = currentEl.textContent.trim();

    // Rewrite the current price display
    currentEl.textContent = formatMoney(saleCents);

    // Insert original price before the current price
    priceWrap.insertBefore(originalEl, currentEl);

    // ── Sale tag ─────────────────────────────────────────────────────────────
    var tagsEl = card.querySelector('.grid-product__tags');
    if (tagsEl && !tagsEl.querySelector('.grid-product__tag--sale')) {
      var saleTag = document.createElement('div');
      saleTag.className = 'grid-product__tag grid-product__tag--sale';
      saleTag.textContent = '-' + cfg.pct + '%';
      tagsEl.appendChild(saleTag);
    }
  }

  // ── Apply to all cards currently in the DOM ──────────────────────────────────
  function applyAll() {
    var cards = document.querySelectorAll('.product-grid-item:not([data-hw-sale-done])');
    for (var i = 0; i < cards.length; i++) {
      applyToCard(cards[i]);
    }
  }

  // ── Run on DOMContentLoaded ──────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAll);
  } else {
    applyAll();
  }

  // ── Watch for AJAX-injected cards (infinite scroll, collection filtering) ───
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length) {
        applyAll();
        break;
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();